module.exports = __webpack_public_path__ + "static/media/img-grow-quote@3x.7eae8179.png";